import Dropdown from "../../components/base/dropdown";

export class HeaderDropdownService {
	constructor($root) {
		this.$root = $root;
		this.$triggers = null;

		this.dropdowns = [];
		this.subscriptions = [];

		this.init();
	}

	init() {
		this.$triggers = this.$root.querySelectorAll('[data-dropdown-trigger]');

		if (!this.$triggers.length) {
			return;
		}

		this.$triggers.forEach(($trigger) => {
			this.initMenu($trigger);
		});
	}

	initMenu($trigger, beforeShow) {
		const $menu = this.$root.querySelector(`[data-dropdown-menu="${$trigger.dataset.dropdownTrigger}"]`);

		if ($menu == null) {
			return;
		}

		this.dropdowns.push(new Dropdown($menu, $trigger, {
			subscriptions: [
				{
					event: 'beforeShow',
					callback: beforeShow ? beforeShow : () => {
						/* Hide all shown dropdowns before to show current */
						this.dropdowns.forEach((dropdown) => {
							if (dropdown.visible) {
								dropdown.hide();
							}
						});
					}
				},
				...this.subscriptions
			]
		}));
	}
}